import { createContext } from 'react';

export const SessionCodeLanguageContext = createContext<{
  sessionLanguages: string[];
  setSessionLanguage(value: string): void;
}>({ sessionLanguages: [], setSessionLanguage: () => null });
